import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { postsMessages } from './postsMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Posts.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostsSelectBarProps {
  pickedCount: number;
  totalCount: number;
  isBusy: boolean;
  onPickAll: () => void;
  onArchive: () => void;
  onDone: () => void;
}

/** The bar of Select mode (design assets-rethink c1 `.selbar`): "N picked · Pick all N · Archive N". */
const PostsSelectBarComponent: React.FC<PostsSelectBarProps> = (props) => {
  const { pickedCount, totalCount, isBusy, onPickAll, onArchive, onDone } = props;
  const intl = useIntl();
  return (
    <div className={styles.selectBar} data-testid="posts-select-bar">
      <b>{intl.formatMessage(postsMessages.picked, { count: pickedCount })}</b>
      <span className={styles.grow} />
      {pickedCount < totalCount && (
        <button type="button" className={styles.link} onClick={onPickAll}>
          {intl.formatMessage(postsMessages.pickAll, { count: totalCount })}
        </button>
      )}
      <button type="button" className={styles.link} onClick={onDone}>
        {intl.formatMessage(postsMessages.selectDone)}
      </button>
      <SMLButton
        color="primary"
        size="sm"
        omitCap
        disabled={pickedCount === 0}
        isLoading={isBusy}
        onClick={onArchive}
        testID="posts-archive-picked"
      >
        {intl.formatMessage(postsMessages.archiveCount, { count: pickedCount })}
      </SMLButton>
    </div>
  );
};

export const PostsSelectBar = TypedMemo(PostsSelectBarComponent);
